<template>
  <div class="card card-custom gutter-b example example-compact">
    <div class="card-header">
      <div class="card-title">
        <router-link v-if="is_admin_dealer" to="/admin/manage/producers" class="mr-5">
          <b-icon icon="arrow-left" scale="1.5"></b-icon>
        </router-link>
        <router-link v-else to="/admin/producers" class="mr-5">
          <b-icon icon="arrow-left" scale="1.5"></b-icon>
        </router-link>
        <h3>Händler bearbeiten - {{form.brandName}}</h3>
      </div>
    </div>
    <div class="card-body">
      <div class="listing-form-main">
        <ValidationObserver ref="newProviderForm">
          <b-form class="form" @submit.stop.prevent="onSubmit">
            <div class="row">
              <div class="col-md-10 form-div">
                <!-- company logo -->
                <div class="row">
                  <div class="col-md-12">
                    <b-form-group id="fieldset-horizontal">
                      <vue-dropzone
                        name="companyLogo"
                        ref="uploadCompanyLogo"
                        id="example-input-0 dropzone"
                        :useCustomSlot="true"
                        :options="logoDropzoneOptions"
                        @vdropzone-file-added="
                          (file) => uploadCompanyLogo(file)
                        "
                        @vdropzone-removed-file="handleRemoveLogo"
                        aria-describedby="input-0-live-feedback"
                      >
                        <div
                          class="dropzone dropzone-default"
                          id="kt_dropzone_1"
                        >
                          <div class="dropzone-msg dz-message needsclick">
                            <h4>Bitte laden sie ein Firmenlogo hoch</h4>
                            <h5>
                              Datei hierhin ziehen oder klicken zum Upload
                            </h5>
                            <p>
                              Erlaubte Formate: JPEG, PNG
                              <br />Maximale Upload-Größe: 1MB
                            </p>
                          </div>
                        </div>
                      </vue-dropzone>
                    </b-form-group>
                  </div>
                </div>
                <!-- end company logo -->
                <div class="row">
                  <div class="col-md-6">
                    <b-form-group id="fieldset-horizontal">
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        :custom-messages="{
                          required: 'Der Vorname ist erforderlich',
                        }"
                      >
                        <v-text-field
                          autocomplete="new-password"
                          v-model="form.firstName"
                          :error-messages="errors[0]"
                          label="Vorname"
                          outlined
                        ></v-text-field>
                      </ValidationProvider>
                    </b-form-group>
                  </div>
                  <div class="col-md-6">
                    <b-form-group id="fieldset-horizontal">
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        :custom-messages="{
                          required: 'Der Nachname ist erforderlich',
                        }"
                      >
                        <v-text-field
                          autocomplete="new-password"
                          v-model="form.lastName"
                          :error-messages="errors[0]"
                          label="Nachname"
                          outlined
                        ></v-text-field>
                      </ValidationProvider>
                    </b-form-group>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-6">
                    <b-form-group id="fieldset-horizontal">
                      <ValidationProvider
                        name="email"
                        rules="required|email"
                        v-slot="{ errors }"
                        :custom-messages="{
                          required: 'Die E-Mail ist erforderlich',
                        }"
                      >
                        <v-text-field
                          autocomplete="new-password"
                          v-model="form.email"
                          :error-messages="errors[0]"
                          label="E-Mail"
                          outlined
                        ></v-text-field>
                      </ValidationProvider>
                    </b-form-group>
                  </div>
                  <div class="col-md-6">
                    <b-form-group id="fieldset-horizontal">
                      <ValidationProvider
                        name="phone"
                        rules="required"
                        v-slot="{ errors }"
                        :custom-messages="{
                          required: 'Die Telefonnummer ist erforderlich',
                        }"
                      >
                        <vue-tel-input
                          :class="errors[0] ? 'error-outline' : ''"
                          v-on:country-changed="countryChanged"
                          :validCharactersOnly="true"
                          :enabledCountryCode="false"
                          :defaultCountry="form.phoneCountry"
                          :onlyCountries="countryArr"
                          mode="international"
                          v-model="form.phone"
                          placeholder="Telefonnummer"
                        ></vue-tel-input>
                      </ValidationProvider>
                    </b-form-group>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <b-form-group id="fieldset-horizontal">
                      <ValidationProvider
                        rules="urlInput"
                        v-slot="{ errors }"
                        :custom-messages="{
                          required: 'Die Firmen-Webseite ist erforderlich',
                        }"
                      >
                        <v-text-field
                          autocomplete="new-password"
                          v-model="form.website"
                          :error-messages="errors[0]"
                          label="Firmen-Webseite"
                          placeholder="zum Beispiel https://www.meinefirma.at"
                          outlined
                        ></v-text-field>
                        <!-- <span>{{ errors[0] }}</span> -->
                      </ValidationProvider>
                    </b-form-group>
                  </div>
                  <div class="col-md-6">
                    <b-form-group id="fieldset-horizontal">
                      <!-- <ValidationProvider
                        rules=""
                        v-slot="{ errors }"
                        :custom-messages="{
                          required: 'UID Nummer ist erforderlich',
                        }"
                      > -->
                      <v-text-field
                        v-model="form.uid"
                        label="UID Nummer"
                        outlined
                      ></v-text-field>
                      <!-- </ValidationProvider> -->
                    </b-form-group>
                  </div>
                </div>
                <v-divider></v-divider>
                <b-form-group id="fieldset-horizontal">
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    :custom-messages="{
                      required: 'Der Markenname ist erforderlich',
                    }"
                  >
                    <v-text-field
                      autocomplete="new-password"
                      v-model="form.brandName"
                      :error-messages="errors[0]"
                      label="Markenname"
                      outlined
                      @input="createSlug"
                    ></v-text-field>
                  </ValidationProvider>
                </b-form-group>

                <b-form-group id="fieldset-horizontal">
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    :custom-messages="{
                      required: 'Der Firmenname ist erforderlich',
                    }"
                  >
                    <v-text-field
                      autocomplete="new-password"
                      v-model="form.companyName"
                      :error-messages="errors[0]"
                      label="Firmenname"
                      outlined
                    ></v-text-field>
                  </ValidationProvider>
                </b-form-group>

                <div class="row">
                  <div class="col-md-12">
                    <b-form-group id="fieldset-horizontal">
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        :custom-messages="{
                          required: 'Category is required.',
                        }"
                      >
                        <v-combobox
                          v-model="form.producerCategories"
                          :items="categories"
                          :error-messages="errors[0]"
                          label="Kategorie"
                          item-text="category_name"
                          item-value="id"
                          multiple
                          outlined
                        ></v-combobox>
                        <!-- <span>{{ errors[0] }}</span> -->
                      </ValidationProvider>
                    </b-form-group>
                  </div>
                </div>

                <b-form-group id="fieldset-horizontal">
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    :custom-messages="{
                      required: 'Address is required.',
                    }"
                  >
                    <v-text-field
                      autocomplete="new-password"
                      v-model="form.producerAddress"
                      :error-messages="errors[0]"
                      label="Adresse"
                      outlined
                    ></v-text-field>
                  </ValidationProvider>
                </b-form-group>

                <div class="row">
                  <div class="col-md-6">
                    <b-form-group id="fieldset-horizontal">
                      <ValidationProvider
                        name="Country"
                        rules="required|alpha"
                        v-slot="{ errors }"
                        :custom-messages="{
                          required: 'Der Land ist erforderlich',
                        }"
                      >
                        <v-text-field
                          type="text"
                          autocomplete="new-password"
                          v-model="form.country"
                          :error-messages="errors[0]"
                          label="Land"
                          outlined
                        ></v-text-field>
                      </ValidationProvider>
                    </b-form-group>
                  </div>
                  <div class="col-md-6">
                    <b-form-group id="fieldset-horizontal">
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        :custom-messages="{
                          required: 'Die Bundesland ist erforderlich',
                        }"
                      >
                        <v-select
                          :items="statesList"
                          v-model="form.state"
                          :error-messages="errors[0]"
                          item-text="name"
                          item-value="id"
                          label="Bundesland"
                          outlined
                          clearable
                        />
                      </ValidationProvider>
                    </b-form-group>
                  </div>
                  <div class="col-md-6">
                    <b-form-group id="fieldset-horizontal">
                      <ValidationProvider
                        name="City"
                        rules="required"
                        v-slot="{ errors }"
                        :custom-messages="{
                          required: 'Die Stadt ist erforderlich',
                        }"
                      >
                        <v-text-field
                          type="text"
                          autocomplete="new-password"
                          v-model="form.city"
                          :error-messages="errors[0]"
                          label="Stadt"
                          outlined
                        ></v-text-field>
                      </ValidationProvider>
                    </b-form-group>
                  </div>
                  <div class="col-md-6">
                    <b-form-group id="fieldset-horizontal">
                      <ValidationProvider
                        name="Postal Code"
                        rules="required"
                        v-slot="{ errors }"
                        :custom-messages="{
                          required: 'die Postleitzahl ist erforderlich',
                        }"
                      >
                        <v-text-field
                          type="text"
                          autocomplete="new-password"
                          v-model="form.postCode"
                          :error-messages="errors[0]"
                          label="Postleitzahl"
                          outlined
                        ></v-text-field>
                      </ValidationProvider>
                    </b-form-group>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <b-form-group id="fieldset-horizontal">
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        :custom-messages="{
                          required: 'Die Firmenbeschreibung ist erforderlich',
                        }"
                      >
                        <!-- <vue-editor
                          placeholder="Firmenbeschreibung"
                          :class="errors[0] ? 'error-outline' : ''"
                          v-model="form.companyDescription"
                        ></vue-editor> -->
                        <ckeditor
                          v-model="form.companyDescription"
                          :config="editorConfig"
                          @blur="getEditorData(form.companyDescription)"
                        ></ckeditor>
                        <span class="text-danger"
                          ><b>{{ errors[0] }}</b></span
                        >
                      </ValidationProvider>
                    </b-form-group>
                  </div>
                </div>
                <!-- company images -->
                <b-form-group id="fieldset-horizontal">
                  <span>Sie können noch weitere Bilder hochladen</span>
                  <vue-dropzone
                    name="companyPictures"
                    ref="uploadProducerImages"
                    id="example-input-0 dropzone"
                    :useCustomSlot="true"
                    :options="dropzoneOptions"
                    @vdropzone-file-added="(file) => uploadFile(file)"
                    @vdropzone-removed-file="handleRemoveImage"
                    aria-describedby="input-0-live-feedback"
                  >
                    <div class="dropzone dropzone-default" id="kt_dropzone_1">
                      <div class="dropzone-msg dz-message needsclick">
                        <h4>Bitte laden sie Bilder zum Unternehmen hoch</h4>
                        <h5>Dateien hierhin ziehen oder klicken zum Upload</h5>
                        <p>
                          Allowed format: JPEG, PNG
                          <br />Maximum upload size: 1MB
                        </p>
                      </div>
                    </div>
                  </vue-dropzone>
                </b-form-group>
                <!-- end company images -->
                <v-divider></v-divider>
                <div class="row">
                  <div class="col-md-6">
                    <span>
                      Diese Provision wird auf alle Bestellungen angewendet
                    </span>
                    <b-form-group class="mt-5">
                      <ValidationProvider
                        rules="priceInput"
                        v-slot="{ errors }"
                        :custom-messages="{
                          required: 'This is required.',
                        }"
                      >
                        <v-text-field
                          :error-messages="errors[0]"
                          autocomplete="new-password"
                          v-model="form.commission"
                          label="Provision (%)"
                          outlined
                          clearable
                        ></v-text-field>
                      </ValidationProvider>
                    </b-form-group>
                  </div>
                </div>
                <h5>Zahlungsanbieter Details</h5>
                <span><b>1. Stripe</b></span>
                <div class="row my-3">
                  <div class="col-md-6">
                    <b-form-group id="fieldset-horizontal">
                      <!-- <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        :custom-messages="{
                          required: 'Der ist erforderlich',
                        }"
                      > -->
                      <v-text-field
                        type="text"
                        autocomplete="new-password"
                        v-model="form.stripePublicKey"
                        label="Stripe öffentlicher Schlüssel (Public Key)"
                        outlined
                      ></v-text-field>
                      <!-- </ValidationProvider> -->
                    </b-form-group>
                  </div>
                  <div class="col-md-6">
                    <b-form-group id="fieldset-horizontal">
                      <!-- <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        :custom-messages="{
                          required: 'Die ist erforderlich',
                        }"
                      > -->
                      <v-text-field
                        type="text"
                        autocomplete="new-password"
                        v-model="form.stripeSecretKey"
                        label="Stripe geheimer Schlüssel (Secret Key)"
                        outlined
                      ></v-text-field>
                      <!-- </ValidationProvider> -->
                    </b-form-group>
                  </div>
                </div>

                <span><b>2. PayPal</b></span>
                <div class="row my-3">
                  <div class="col-md-12">
                    <b-form-group id="fieldset-horizontal">
                      <v-text-field
                        type="text"
                        autocomplete="new-password"
                        v-model="form.paypalEmail"
                        label="Paypal Anmelde-Adresse"
                        outlined
                      ></v-text-field>
                    </b-form-group>
                  </div>
                  <!-- <div class="col-md-6">
                    <b-form-group id="fieldset-horizontal">
                      
                      <v-text-field
                        type="text"
                        autocomplete="new-password"
                        v-model="form.paypalClientId"
                        label="PayPal Client ID"
                        outlined
                      ></v-text-field>
                    </b-form-group>
                  </div> -->
                  <!-- <div class="col-md-6">
                    <b-form-group id="fieldset-horizontal">
                      <v-text-field
                        type="text"
                        autocomplete="new-password"
                        v-model="form.paypalSecretKey"
                        label="PaypPal geheimer Schlüssel (Secret Key)"
                        outlined
                      ></v-text-field>
                    </b-form-group>
                  </div> -->
                </div>

                <span><b>3. Mollie</b></span>
                <div class="row my-3">
                  <div class="col-md-12">
                    <b-form-group id="fieldset-horizontal">
                      <!-- <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        :custom-messages="{
                          required: 'Der ist erforderlich',
                        }"
                      > -->
                      <v-text-field
                        type="text"
                        autocomplete="new-password"
                        v-model="form.mollieKey"
                        label="Mollie Schlüssel (Key)"
                        outlined
                      ></v-text-field>
                      <!-- </ValidationProvider> -->
                    </b-form-group>
                  </div>
                </div>

                <span><b>4. Klarna</b></span>
                <div class="row my-3">
                  <div class="col-md-6">
                    <b-form-group id="fieldset-horizontal">
                      <!-- <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        :custom-messages="{
                          required: 'Der ist erforderlich',
                        }"
                      > -->
                      <v-text-field
                        type="text"
                        autocomplete="new-password"
                        v-model="form.klarnaUsername"
                        label="Klarna API Benutzername"
                        outlined
                      ></v-text-field>
                      <!-- </ValidationProvider> -->
                    </b-form-group>
                  </div>
                  <div class="col-md-6">
                    <b-form-group id="fieldset-horizontal">
                      <!-- <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        :custom-messages="{
                          required: 'Der ist erforderlich',
                        }"
                      > -->
                      <v-text-field
                        type="text"
                        autocomplete="new-password"
                        v-model="form.klarnaPassword"
                        label="Klarna API Passwort"
                        outlined
                      ></v-text-field>
                      <!-- </ValidationProvider> -->
                    </b-form-group>
                  </div>
                </div>

                <span><b>5. Sumup</b></span>
                <div class="row mt-3">
                  <div class="col-md-6">
                    <b-form-group id="fieldset-horizontal">
                      <!-- <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        :custom-messages="{
                          required: 'Der ist erforderlich',
                        }"
                      > -->
                      <v-text-field
                        type="text"
                        autocomplete="new-password"
                        v-model="form.sumupClientId"
                        label="SumUp Client ID"
                        outlined
                      ></v-text-field>
                      <!-- </ValidationProvider> -->
                    </b-form-group>
                  </div>
                  <div class="col-md-6">
                    <b-form-group id="fieldset-horizontal">
                      <!-- <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        :custom-messages="{
                          required: 'Der ist erforderlich',
                        }"
                      > -->
                      <v-text-field
                        type="text"
                        autocomplete="new-password"
                        v-model="form.sumupClientSecret"
                        label="SumUp Client Secret"
                        outlined
                      ></v-text-field>
                      <!-- </ValidationProvider> -->
                    </b-form-group>
                  </div>
                  <div class="col-md-6">
                    <b-form-group id="fieldset-horizontal">
                      <ValidationProvider
                        rules="email"
                        v-slot="{ errors }"
                        :custom-messages="{
                          required: 'Der ist erforderlich',
                        }"
                      >
                        <v-text-field
                          type="text"
                          autocomplete="new-password"
                          v-model="form.sumupEmail"
                          :error-messages="errors[0]"
                          label="SumUp E-Mail"
                          outlined
                        ></v-text-field>
                      </ValidationProvider>
                    </b-form-group>
                  </div>
                </div>
                 <!-- social media links -->
                <v-divider></v-divider>
                <div
                  class="row"
                  v-for="(sinfo, i) in form.socialMediaInfo"
                  :key="'L' + i"
                >
                  <div class="col-md-5">
                    <b-form-group id="fieldset-horizontal">
                      <v-select
                        :items="socialMedias"
                        v-model="sinfo.name"
                        item-text="name"
                        item-value="name"
                        label="Social Media"
                        outlined
                        clearable
                      />
                    </b-form-group>
                  </div>
                  <div class="col-md-6">
                    <b-form-group id="fieldset-horizontal">
                      <ValidationProvider
                        rules="urlInput"
                        v-slot="{ errors }"
                        :custom-messages="{
                          required: 'Die ist erforderlich',
                        }"
                      >
                        <v-text-field
                          autocomplete="new-password"
                          v-model="sinfo.link"
                          :error-messages="errors[0]"
                          label="Social Media Link"
                          outlined
                        ></v-text-field>
                      </ValidationProvider>
                    </b-form-group>
                  </div>
                  <div
                    v-if="i > 0"
                    class="col-md-1 plus-circle-btn removeService"
                  >
                    <a @click="removeSocialSites(i)"
                      ><b-icon icon="x-circle"></b-icon
                    ></a>
                  </div>
                  <div class="col-md-1 plus-circle-btn" v-else>
                    <a @click="addSocialSites"
                      ><b-icon icon="plus-circle"></b-icon
                    ></a>
                  </div>
                </div>
                <!-- end social media links -->
                <v-divider></v-divider>
                <!-- Meta description added -->
                <div class="row">
                  <div class="col-md-12">
                    <b-form-group id="fieldset-horizontal">
                      <ValidationProvider
                        rules="required|max160"
                        v-slot="{ errors }"
                        :custom-messages="{
                          required: 'Händler Meta Beschreibung ist erforderlich',
                        }"
                      >
                        <!-- <ckeditor
                          v-model="form.productMetaDescription"
                          :config="editorConfig"
                        ></ckeditor> -->
                        <v-text-field
                          v-model="form.producerMetaDescription"
                          :error-messages="errors[0]"
                          label="Händler Meta Beschreibung für SEO (max. 160 Zeichen, Standard: Händler Beschreibungstext)"
                          outlined
                          @blur="restorePopUp(e=3)"
                        ></v-text-field>
                        <span v-if="form.producerMetaDescription && form.producerMetaDescription.length > 160" class="text-danger"><b>{{ errors[0] }}</b></span>
                      </ValidationProvider>
                    </b-form-group>
                  </div>
                </div>
                <v-divider></v-divider>
                <div class="row">
                  <div class="col-md-6">
                    <b-form-group id="fieldset-horizontal">
                      <ValidationProvider
                        rules="required|max50"
                        v-slot="{ errors }"
                        :custom-messages="{
                          required: 'Händler Name ist erforderlich',
                        }"
                      >
                        <v-text-field
                          v-model="form.producerMetaTitle"
                          :error-messages="errors[0]"
                          label="Händler Meta Name für SEO (max. 50 Zeichen, Standard: Händler Name)"
                          outlined
                          @blur="restorePopUp(e=1)"
                        ></v-text-field>
                        <span v-if="form.producerMetaTitle && form.producerMetaTitle.length >50" class="text-danger"><b>{{ errors[0] }}</b></span>
                      </ValidationProvider>
                    </b-form-group>
                  </div>
                  <div class="col-md-6">

                  </div>
                </div>
                <v-divider></v-divider>
                <div class="row">
                  <div class="col-md-6">
                    <b-form-group id="fieldset-horizontal">
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        :custom-messages="{
                          required: 'Händler Canonical Link ist erforderlich',
                        }"
                      >
                        <v-text-field
                            v-model="form.producerCanonicalLink"
                            :error-messages="errors[0]"
                            label="Händler Canonical Link für SEO (Standard: Händler URL)"
                            outlined
                            @blur="restorePopUp(e=2)"
                          ></v-text-field>
                        </ValidationProvider>
                    </b-form-group>
                  </div>
                  <div class="col-md-6">
                    <b-form-group id="fieldset-horizontal">
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        :custom-messages="{
                          required: 'Händler Meta Robots ist erforderlich',
                        }"
                      >
                        <v-select
                            :items="robotValues"
                            v-model="form.producerMetaRobots"
                            :error-messages="errors[0]"
                            item-text="lable"
                            item-value="value"
                            label="Händler Meta Robots Einstellung für SEO (Standard: index, follow)"
                            outlined clearable
                          />
                        </ValidationProvider>
                    </b-form-group>
                  </div>
                </div>
                <v-divider></v-divider>                
                <b-form-group class="mt-5">
                  <v-switch
                    v-model="status"
                    inset
                    :label="status == true ? 'Aktiviert' : 'Deaktiviert'"
                    class="d-inline-block"
                  ></v-switch>
                </b-form-group>

                <div class="fo-row-btn text-right">
                  <v-btn class="submit-btn-fill-outline" @click="goToBack">
                    Abbrechen
                  </v-btn>
                  <v-btn
                    type="submit"
                    :disabled="isDisabled"
                    ref="kt_form_submit_btn"
                    class="submit-btn-fill-color"
                  >
                    {{ submitText }}
                  </v-btn>
                  <!-- <br />
              <span class="form-errors" v-if="formError"
                >One or more fields has error. Please check form again.</span
              > -->
                </div>
              </div>
            </div>
          </b-form>
        </ValidationObserver>
        <v-dialog v-model="statusDialog" width="500">
          <v-card>
            <v-card-title class="headline grey lighten-2">
              Bitte bestätigen
            </v-card-title>
            <v-card-text>
              <span>Möchten Sie den Wert wiederherstellen?</span>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-btn
                :disabled="disabledCancel"
                class="no-button"
                @click="hideModal"
              >
                Nein
              </v-btn>
              <v-btn
                type="submit"
                @click="restore()"
                ref="kt_form_submit_btn"
                class="yes-button"
                :loading="yesActionLoading"
              >
                Ja
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </div>
    <notifications group="producers" position="bottom right" />
  </div>
</template>

<script>
import Vue from "vue";
import { mapGetters } from "vuex";
//import axios from "axios";
import Notifications from "vue-notification";
//import JwtService from "@/core/services/jwt.service";
import HtmlClass from "@/core/services/htmlclass.service";
//import KTScrollTop from "@/components/admin/layout/extras/ScrollTop";
//import Loader from "@/components/admin/layout/Loader.vue";
//import { alpha } from 'vee-validate';
import config from "@/config/app";
import {
  ADD_BODY_CLASSNAME,
  REMOVE_BODY_CLASSNAME,
} from "@/core/services/store/htmlclass.module.js";
import JwtService from "@/core/services/jwt.service";
import VueTelInput from "vue-tel-input";
import adminAPI from "@/api/admin";
import CKEditor from "ckeditor4-vue";
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import providerAPI from "@/api/provider";
import { alpha } from "vee-validate";
import { extend } from "vee-validate";
import metarobots from "@/config/constant";

Vue.use(CKEditor);
Vue.use(VueTelInput);
Vue.use(Notifications);

extend("noSpecialCharacters", {
  message: (field) => "Bitte entfernen Sonderzeichen",
  validate: (value) => {
    var regx = /^[a-zA-Z0-9\s]*$/;
    var validInput = regx.test(value);
    if (validInput) {
      return true;
    } else {
      false;
    }
  },
});

extend("urlInput", {
  message: (field) =>
    "Bitte geben sie eine gültige URL ein, die mit http:// oder https:// beginnt",
  validate: (value) => {
    var regx =
      /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/;
    var validUrl = regx.test(value);
    if (validUrl) {
      return true;
    } else {
      false;
    }
  },
});

extend("priceInput", {
  message: (field) => "enter valid value",
  validate: (value) => {
    var regx = /^[0-9.,]+$/;
    var validInput = regx.test(value);
    if (validInput) {
      return true;
    } else {
      false;
    }
  },
});

extend("max160", {
  message: (field) => "Händler Meta Beschreibung: maximal 160 Zeichen",
  validate: (value) => {
    var regx = /^.{0,160}$/;
    var validInput = regx.test(value);
    if (validInput) {
      return true;
    } else {
      false;
    }
  },
});

extend("max50", {
  message: (field) => "Händler Meta Name: maximal 50 Zeichen",
  validate: (value) => {
    var regx = /^.{0,50}$/;
    var validInput = regx.test(value);
    if (validInput) {
      return true;
    } else {
      false;
    }
  },
});

export default {
  name: "EditProducer",
  components: {
    vueDropzone: vue2Dropzone,
  },
  props:{
    data: {
      type: String,
      required: true
    }
  },
  created() {
    if (!this.isAuthenticated) {
      this.$router.push({ name: "Login" });
    } else {
      // show page loading
      this.$store.dispatch(ADD_BODY_CLASSNAME, "page-loading");
      HtmlClass.init(this.layoutConfig());
      this.userId = localStorage.getItem("local_products_user_access_id");
      if(localStorage.getItem("currentProviderCountry") && localStorage.getItem("currentProviderCountry") != 'undefined'){
        this.form.phoneCountry = localStorage.getItem("currentProviderCountry");
      }
      this.form.phone = localStorage.getItem("currentProviderPhone");
      this.getCategories();
      this.getProviderData();
      this.getStates();
      this.robotValues = metarobots;
      if(this.robotValues.length > 0){
       this.form.producerMetaRobots = this.robotValues[0].value
      }

    }
    console.log('editttt', this.is_admin_dealer)
  },
  data() {
    return {
      is_admin_dealer:this.data ? this.data: 0,
      countryArr: config.availableCountries,
      formError: false,
      userId: null,
      isLoading: false,
      pdfFileString: null,
      formData: [],
      robotValues: [],
      statesList: [],
      oldImages: [],
      pdfFileTest: "",
      btnDisable: false,
      countryDialCode: "43",
      submitText: "Abschicken",
      status: false,
      old_status: null,
      radioItems: [
        {
          key: "Enable",
          value: "1",
        },
        {
          key: "Disable",
          value: "0",
        },
      ],
      old_email: "",
      currentImage: null,
      form: {
        firstName: null,
        lastName: null,
        email: null,
        phone: null,
        companyName: "",
        brandName: "",
        producerAddress: "",
        companyDescription: "",
        country: "",
        state: "",
        city: "",
        postCode: "",
        phoneCountry: "AT",
        commission: "",
        logo: "",
        producerImages: [],
        producerCategories: [],
        stripePublicKey: "",
        stripeSecretKey: "",
        paypalEmail: "",
        paypalClientId: "",
        paypalSecretKey: "",
        mollieKey: "",
        klarnaUsername: "",
        klarnaPassword: "",
        sumupClientId: "",
        sumupClientSecret: "",
        sumupEmail: "",
        website: "",
        uid: "",
        socialMediaInfo: [],
        producerMetaDescription:"",
        producerMetaTitle:"",
        producerCanonicalLink:"",
        producerMetaRobots: ""
      },
      uid: "",
      dropzoneOptions: {
        url: config.API_URL + "add-product",
        thumbnailWidth: 150,
        maxFilesize: 1,
        maxFiles: 10,
        addRemoveLinks: true,
        autoProcessQueue: false,
        timeout: 20000000,
        acceptedFiles: ".jpeg, .jpg, .png",
        uploadMultiple: true,
        headers: { Authorization: `Bearer ${JwtService.getToken()}` },
      },
      logoDropzoneOptions: {
        url: config.API_URL + "add-product",
        thumbnailWidth: 150,
        maxFilesize: 1,
        maxFiles: 1,
        addRemoveLinks: true,
        autoProcessQueue: false,
        timeout: 20000000,
        acceptedFiles: ".jpeg, .jpg, .png",
        uploadMultiple: false,
        uploadprogress: false,
      },
      categories: [],
      editorConfig: {
        language: 'de',scayt_sLang : 'de_DE'
      },
      phoneCountry: "",
      socialMedias: [
        {
          name: "Facebook",
        },
        {
          name: "Twitter",
        },
        {
          name: "LinkedIn",
        },
        {
          name: "Instagram",
        },
        {
          name: "XING",
        },
        {
          name: "Pinterest",
        },
        {
          name: "Reddit",
        },
        {
          name: "Tumblr",
        },
      ],
      editProducerMetaTitle:false,
      statusDialog: false,
      restoreField:null,
      imgRequired:false,
      logoimgRequired:false,
    };
  },
  watch: {
    "form.brandName": function (value) {
      if(this.editProducerMetaTitle){
        this.form.producerMetaTitle = value.substring(0,50);
      }
    },
  },
  methods: {
    getGeneralSettings() {
      adminAPI
        .getGeneralSetting({ id: this.currentUser.id })
        .then((response) => {
          if (response.status == "success") {
            if (!this.form.commission) {
              this.form.commission = response.data.dealer_commission;
            }
            if (!this.form.tax) {
              this.form.tax = response.data.tax;
            }
          }
        })
        .catch((err) => {});
    },
    getStates() {
      adminAPI
        .getStates()
        .then((response) => {
          if (response.status == "success") {
            this.statesList = response.data;
          } else {
            this.$notify({
              group: "products",
              type: "error",
              position: "bottom right",
              text: response.msg,
              duration: 3000,
            });
          }
        })
        .catch((err) => {
          this.$notify({
            group: "products",
            type: "error",
            position: "bottom right",
            text: err,
            duration: 3000,
          });
        });
    },
    goToBack() {
      if (this.is_admin_dealer) {
        this.$router.push({ name: "manage-producers" });
      } else {
        this.$router.push({ name: "producers" });
      }
    },
    countryChanged(country) {
      this.countryDialCode = country.dialCode;
      this.form.phoneCountry = country.iso2;
    },
    getProviderData() {
      adminAPI
        .editProducer({ id: this.$route.params.id, is_admin_dealer:this.is_admin_dealer })
        .then((response) => {
          if (response.status == "success") {
            this.form.firstName = response.data.first_name;
            this.form.lastName = response.data.last_name;
            this.form.producerMetaDescription = response.data.producer_detail.meta_description;
            localStorage.setItem("producerMetaDescription", this.form.producerMetaDescription);
            this.form.producerMetaTitle = response.data.producer_detail.title;
            this.form.producerCanonicalLink = response.data.producer_detail.canonical_link;
            if (response.data.producer_detail.meta_robots) {
              this.form.producerMetaRobots = response.data.producer_detail.meta_robots;  
            }
            this.form.email = response.data.email;
            this.old_email = response.data.email;
            this.status = response.data.is_status == 1 ? true : false;
            this.old_status = response.data.is_status == 1 ? true : false;
            if (response.data.producer_detail) {
              this.form.producerAddress = response.data.producer_detail.address;
              if (!response.data.producer_detail.country) {
                this.form.country = "Österreich";
              } else {
                this.form.country = response.data.producer_detail.country;
              }
              this.form.state = response.data.producer_detail.state_id;
              this.form.companyName =
                response.data.producer_detail.company_name;
              this.form.brandName = response.data.producer_detail.brand_name;
              this.form.city = response.data.producer_detail.city;
              this.form.postCode = response.data.producer_detail.postcode;
              this.form.commission = response.data.producer_detail.commission;
              this.form.website = response.data.producer_detail.website
                  ? response.data.producer_detail.website
                  : "";
              this.form.uid = response.data.producer_detail.uid ? response.data.producer_detail.uid : "";
              this.form.companyDescription = response.data.producer_detail.description
                  ? response.data.producer_detail.description
                  : "";
              if (response.data.producer_detail.categories.length) {
                  response.data.producer_detail.categories.forEach((item) => {
                    if (item.category_detail) {
                      this.form.producerCategories.push({
                        category_name: item.category_detail.category_name,
                        id: item.category_id,
                      });
                    }
                  });
              }

              if (response.data.producer_detail.payment_details) {
                  this.form.stripePublicKey = response.data.producer_detail.payment_details
                    .stripe_public_key
                    ? response.data.producer_detail.payment_details.stripe_public_key
                    : "";
                  this.form.stripeSecretKey = response.data.producer_detail.payment_details
                    .stripe_secret_key
                    ? response.data.producer_detail.payment_details.stripe_secret_key
                    : "";
                  this.form.paypalClientId = response.data.producer_detail.payment_details
                    .paypal_client_id
                    ? response.data.producer_detail.payment_details.paypal_client_id
                    : "";
                  this.form.paypalEmail = response.data.producer_detail.payment_details
                    .paypal_email
                    ? response.data.producer_detail.payment_details.paypal_email
                    : "";
                  this.form.paypalSecretKey = response.data.producer_detail.payment_details
                    .paypal_secret
                    ? response.data.producer_detail.payment_details.paypal_secret
                    : "";
                  this.form.mollieKey = response.data.producer_detail.payment_details.mollie_key
                    ? response.data.producer_detail.payment_details.mollie_key
                    : "";
                  this.form.klarnaUsername = response.data.producer_detail.payment_details
                    .klarna_api_username
                    ? response.data.producer_detail.payment_details.klarna_api_username
                    : "";
                  this.form.klarnaPassword = response.data.producer_detail.payment_details
                    .klarna_api_password
                    ? response.data.producer_detail.payment_details.klarna_api_password
                    : "";
                  this.form.sumupClientId = response.data.producer_detail.payment_details
                    .sumup_client_id
                    ? response.data.producer_detail.payment_details.sumup_client_id
                    : "";
                  this.form.sumupClientSecret = response.data.producer_detail.payment_details
                    .sumup_client_secret
                    ? response.data.producer_detail.payment_details.sumup_client_secret
                    : "";
                  this.form.sumupEmail = response.data.producer_detail.payment_details
                    .sumup_email
                    ? response.data.producer_detail.payment_details.sumup_email
                    : "";
                }

              if (response.data.producer_detail.social_links.length) {
                  response.data.producer_detail.social_links.forEach((item) => {
                    this.form.socialMediaInfo.push({
                      name: item.name,
                      link: item.link,
                    });
                  });
                } else {
                  this.form.socialMediaInfo.push({
                    name: "",
                    link: "",
                  });
                }

              if (response.data.producer_detail.pictures.length) {
                  this.acceptImageLength = 4 - response.data.producer_detail.pictures.length;
                  this.oldImages = response.data.producer_detail.pictures;
                  response.data.producer_detail.pictures.forEach((item, i) => {
                    if (
                      item.photo_path.indexOf(".jpg") !== -1 ||
                      item.photo_path.indexOf(".jpeg") !== -1
                    ) {
                      var file = {
                        size: 12345,
                        name: item.photo_name,
                        type: "image/jpeg",
                      };
                      this.$refs.uploadProducerImages.manuallyAddFile(
                        file,
                        item.photo_path
                      );
                    }
                    if (item.photo_path.indexOf(".png") !== -1) {
                      var file = {
                        size: 12345,
                        name: item.photo_name,
                        type: "image/png",
                      };
                      this.$refs.uploadProducerImages.manuallyAddFile(
                        file,
                        item.photo_path
                      );
                    }
                  });
                }
              // LOGO IMAGE
              this.form.logo = response.data.producer_detail.logo_path;
              this.currentImage = response.data.producer_detail.logo_path;
              if (response.data.producer_detail.logo_path) {
                  if (
                    response.data.producer_detail.logo_path.indexOf(".jpg") !== -1 ||
                    response.data.producer_detail.logo_path.indexOf(".jpeg") !== -1
                  ) {
                    var file = {
                      size: 12345,
                      name: response.data.producer_detail.logo_path,
                      type: "image/jpeg",
                    };
                    this.$refs.uploadCompanyLogo.manuallyAddFile(
                      file,
                      response.data.producer_detail.logo_path
                    );
                  }
                  if (response.data.producer_detail.logo_path.indexOf(".png") !== -1) {
                    var file = {
                      size: 12345,
                      name: response.data.producer_detail.logo_path,
                      type: "image/png",
                    };
                    this.$refs.uploadCompanyLogo.manuallyAddFile(
                      file,
                      response.data.producer_detail.logo_path
                    );
                  }
                }
            }
            this.form.phone = response.data.mobile_no;
            if(!this.form.producerMetaTitle){
              this.form.producerMetaTitle = this.form.brandName;
            }
            if(this.form.producerMetaTitle === this.form.brandName){
              this.editProducerMetaTitle = true;
            }

            this.form.producerCanonicalLink = response.data.producer_detail.canonical_link ?? "";
            if(this.form.producerCanonicalLink ==''|| this.form.producerCanonicalLink == null || this.form.producerCanonicalLink == undefined){
              this.createSlug()
            }

            if(this.form.producerMetaDescription ==''|| this.form.producerMetaDescription == null || this.form.producerMetaDescription == undefined){
              // this.restore_meta_description = true;
              response.data.producer_detail.description ? this.getEditorData(response.data.producer_detail.description) :''
              
            }
            // this.form.phoneCountry = response.data.country;
            this.getGeneralSettings();
            this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
          } else {
            this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
            this.$notify({
              group: "producers",
              type: "error",
              position: "bottom right",
              text: response.msg,
              duration: 3000,
            });
          }
        })
        .catch((err) => {
          this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
          this.$notify({
            group: "producers",
            type: "error",
            position: "bottom right",
            text: err,
            duration: 3000,
          });
        });
    },
    onSubmit() {
      this.$refs.newProviderForm.validate().then((success) => {
        if (success && !this.imgRequired && !this.logoimgRequired) {
          this.formError = false;
          this.btnDisable = true;
          this.submitText = "Wird abgeschickt...";
          const categories = [];
          for (var i = 0; i < this.form.producerCategories.length; i++) {
            categories.push(this.form.producerCategories[i].id);
          }
          var oldFiles = [];
          // console.log(this.oldImages)
          if (this.oldImages) {
            for (var i = 0; i < this.oldImages.length; i++) {
              oldFiles.push(this.oldImages[i].photo_name);
            }
          }

          //-----country code
          const germanyPattern = /^(\+|00)49/;
          const austriaPattern = /^(\+|00)43/;

          // Check if the phone number matches either pattern
          const isGermanNumber = germanyPattern.test(this.form.phone);
          const isAustrianNumber = austriaPattern.test(this.form.phone);

          if (isGermanNumber) {
            console.log('+49 (Germany)');
          } else if (isAustrianNumber) {
            console.log('+43 (Austria)');
          } else {
            var phoneNumber = this.form.phone
            this.form.phone = '+'+this.countryDialCode+' '+phoneNumber
          }

          //-----------
          
          let formData = new FormData();
          formData.append("is_admin_dealer", this.is_admin_dealer);
          formData.append("user_id", this.currentUser.id);
          formData.append("id", this.$route.params.id);
          formData.append("first_name", this.form.firstName);
          formData.append("last_name", this.form.lastName);
          formData.append("email", this.form.email);
          formData.append("old_email", this.old_email);
          formData.append("phone", this.form.phone);
          formData.append("country_code", this.form.phoneCountry);
          formData.append("brand_name", this.form.brandName);
          formData.append("company_name", this.form.companyName);
          formData.append("address", this.form.producerAddress);
          formData.append("uid", this.form.uid);
          formData.append("country", this.form.country);
          formData.append("state_id", this.form.state);
          formData.append("city", this.form.city);        
          formData.append("postcode", this.form.postCode);
          formData.append("stripe_public_key", this.form.stripePublicKey);
          formData.append("stripe_secret_key", this.form.stripeSecretKey);
          formData.append("paypal_email", this.form.paypalEmail);
          formData.append("paypal_client_id", this.form.paypalClientId);
          formData.append("paypal_secret", this.form.paypalSecretKey);
          formData.append("mollie_key", this.form.mollieKey);
          formData.append("klarna_api_username", this.form.klarnaUsername);
          formData.append("klarna_api_password", this.form.klarnaPassword);
          formData.append("sumup_client_id", this.form.sumupClientId);
          formData.append("sumup_client_secret", this.form.sumupClientSecret);
          formData.append("sumup_email", this.form.sumupEmail);
          formData.append("country_dial_code", "+" + this.countryDialCode);

          formData.append("meta_description", this.form.producerMetaDescription ? this.form.producerMetaDescription : '');
          formData.append("title", this.form.producerMetaTitle ? this.form.producerMetaTitle : '');
          formData.append("canonical_link", this.form.producerCanonicalLink ? this.form.producerCanonicalLink : '');
          formData.append("meta_robots", this.form.producerMetaRobots ? this.form.producerMetaRobots : '');
          formData.append(
            "company_description",
            this.form.companyDescription
          );
          formData.append("website", this.form.website);
          formData.append(
            "social_informations",
            JSON.stringify(this.form.socialMediaInfo)
          );
          formData.append("producer_categories", JSON.stringify(categories));
          formData.append("commission", this.form.commission);
          let status = this.status == true ? "1" : "0";
          formData.append("status", status);
          let old_status = this.old_status == true ? "1" : "0";
          formData.append("old_status", old_status);
          formData.append("image_changed", this.imageChanged);
          formData.append("company_logo", this.form.logo);
          formData.append("old_file", oldFiles);
          /*let formData = {
            id: this.$route.params.id,
            first_name: this.form.firstName,
            last_name: this.form.lastName,
            email: this.form.email,
            old_email: this.old_email,
            phone: this.form.phone,
            country_code: this.form.phoneCountry,
            brand_name: this.form.brandName,
            company_name: this.form.companyName,
            address: this.form.producerAddress,
            uid: this.form.uid,
            country: this.form.country,
            state_id: this.form.state,
            city: this.form.city,
            postcode: this.form.postCode,
            stripe_public_key: this.form.stripePublicKey,
            stripe_secret_key: this.form.stripeSecretKey,
            paypal_email: this.form.paypalEmail,
            paypal_client_id: this.form.paypalClientId,
            paypal_secret: this.form.paypalSecretKey,
            mollie_key: this.form.mollieKey,
            klarna_api_username: this.form.klarnaUsername,
            klarna_api_password: this.form.klarnaPassword,
            sumup_client_id: this.form.sumupClientId,
            sumup_client_secret: this.form.sumupClientSecret,
            sumup_email: this.form.sumupEmail,
            country_dial_code: "+" + this.countryDialCode,
            company_description: this.form.companyDescription,
            website: this.form.website,
            social_informations: JSON.stringify(this.form.socialMediaInfo),
            producer_categories: JSON.stringify(categories),
            commission: this.form.commission,
            status: this.status == true ? "1" : "0",
            old_status: this.old_status == true ? "1" : "0",
            image_changed: this.imageChanged,
            company_logo: this.form.logo,
            old_file: oldFiles
          };*/
          for (var i = 0; i < this.form.producerImages.length; i++) {
              formData.append("file[" + i + "]", this.form.producerImages[i]);
          }
          // console.log('formData', formData);
          setTimeout(() => {
            adminAPI
              .updateProducer(formData)
              .then((response) => {
                if (response.status == "success") {
                  this.old_email = this.form.email;
                  this.old_status = this.status;
                  this.submitText = "Abschicken";
                  this.btnDisable = false;
                  this.$notify({
                    group: "producers",
                    type: "success",
                    position: "bottom right",
                    text: response.msg,
                    duration: 5000,
                  });
                  setTimeout(() => {
                    if (this.is_admin_dealer) {
                      this.$router.push({ name: "manage-producers" });
                    } else {
                      this.$router.push({ name: "producers" });
                    }
                  }, 2000);
                } else {
                  this.btnDisable = false;
                  this.submitText = "Abschicken";
                  this.$notify({
                    group: "producers",
                    type: "error",
                    position: "bottom right",
                    text: response.msg,
                    duration: 5000,
                  });
                }
              })
              .catch((err) => {
                this.btnDisable = false;
                this.submitText = "Abschicken";
                this.$notify({
                  group: "producers",
                  type: "error",
                  position: "bottom right",
                  text: err,
                  duration: 5000,
                });
              });
          }, 2000);
        } else {
          this.$notify({
            group: "producers",
            type: "error",
            position: "bottom right",
            text: 'fehlender obligatorischer Wert oder falsches Format',
            duration: 5000,
          });
          this.formError = true;
          this.btnDisable = false;
          this.submitText = "Abschicken";
        }
      });
    },
    handleRemoveLogo() {
      this.form.logo = null;
      this.currentImage = null;
      this.logoimgRequired = false;
    },
    handleRemoveImage(file) {
      var array = this.oldImages.filter((elm) => elm.photo_name !== file.name);
      this.oldImages = array;
      this.imgRequired = false;
    },
    getCategories() {
      providerAPI
        .activeCategory()
        .then((response) => {
          if (response.status == "success") {
            this.categories = response.data;
          } else {
            this.$notify({
              group: "providers",
              type: "error",
              position: "bottom right",
              text: response.msg,
              duration: 3000,
            });
          }
        })
        .catch((err) => {
          this.$notify({
            group: "providers",
            type: "error",
            position: "bottom right",
            text: err,
            duration: 3000,
          });
        });
    },
    uploadCompanyLogo(file) {
      setTimeout(() => {
        if (file.status == "queued") {
          this.imageChanged = "1";
          this.form.logo = file;
          this.logoimgRequired = false;
        } else if(file.status == "error"){
            this.logoimgRequired = true;
        }
      }, 1000);
    },
    uploadFile(file) {
      setTimeout(() => {
        if (file.status == "queued") {
          this.form.producerImages.push(file);
          this.imgRequired = false;
        } else if(file.status == "error") {
          
          this.imgRequired = true;
          
        }
      }, 500);
    },
    addSocialSites() {
      this.form.socialMediaInfo.push({
        name: "",
        link: "",
      });
    },
    removeSocialSites(i) {
      this.form.socialMediaInfo.splice(i, 1);
    },
    getEditorData(htmlData) {
      const tempElement = document.createElement('div');
      tempElement.innerHTML = htmlData;
      const plainText = tempElement.textContent;
      let description = plainText.replace(/\r?\n|\r/g, '');
      this.form.producerMetaDescription = description.substring(0,160);
    },
    createSlug() {
      
      let formData = {
            name: this.form.brandName,
      }
      adminAPI
        .createSlug(formData)
        .then((response) => {
          if (response.status == "success") {
            if(window.location.origin === 'http://localhost:8080'){
              this.form.producerCanonicalLink = 'http://localhost:3000/haendler-details/'+response.data.slug
            }else if(window.location.origin === 'https://stage-admin.marktplatzgenius.lcmx.at'){
              this.form.producerCanonicalLink = 'https://stage.marktplatzgenius.lcmx.at/haendler-details/'+response.data.slug
            }else{
              this.form.producerCanonicalLink = 'https://marktplatzgenius.lcmx.at/haendler-details/'+response.data.slug
            }
          } else {
            this.form.producerCanonicalLink = '';
            this.$notify({
              group: "products",
              type: "error",
              position: "bottom right",
              text: response.msg,
              duration: 3000,
            });
          }
        })
        .catch((err) => {
          this.$notify({
            group: "products",
            type: "error",
            position: "bottom right",
            text: err,
            duration: 3000,
          });
        });
    },
    restorePopUp(e){
      if((e=='1') && (!this.form.producerMetaTitle)&& (this.form.brandName) && (this.editProducerMetaTitle)){
        this.restoreField = e;
        this.statusDialog = true;
      }else if((e=='2') && (!this.form.producerCanonicalLink) && (this.form.brandName)){
        this.restoreField = e;
        this.statusDialog = true;
      } else if((e=='3') && (!this.form.producerMetaDescription) && (localStorage.getItem('producerMetaDescription')) && (localStorage.getItem('producerMetaDescription') != 'null')){
        this.restoreField = e;
        this.statusDialog = true;
      }
      
    },
    hideModal(){
      this.statusDialog = false
    },
    restore(){
      if(this.restoreField == '1') {
        this.form.producerMetaTitle = this.form.brandName.substring(0,50);
      }else if(this.restoreField == '2') {
        this.createSlug();
      } else if(this.restoreField == '3'){
        this.form.producerMetaDescription = localStorage.getItem('producerMetaDescription');
      }
      this.statusDialog = false
    }
  },
  computed: {
    ...mapGetters([
      "isAuthenticated",
      "breadcrumbs",
      "pageTitle",
      "layoutConfig",
      "currentUser",
    ]),
    /**
     * Check if the page loader is enabled
     * @returns {boolean}
     */
    loaderEnabled() {
      return !/false/.test(this.layoutConfig("loader.type"));
    },
    /**
     * Check if container width is fluid
     * @returns {boolean}
     */
    contentFluid() {
      return this.layoutConfig("content.width") === "fluid";
    },
    /**
     * Page loader logo image using require() function
     * @returns {string}
     */
    loaderLogo() {
      return process.env.BASE_URL + this.layoutConfig("loader.logo");
    },
    /**
     * Check if the left aside menu is enabled
     * @returns {boolean}
     */
    asideEnabled() {
      return !!this.layoutConfig("aside.self.display");
    },
    /**
     * Set the right toolbar display
     * @returns {boolean}
     */
    toolbarDisplay() {
      // return !!this.layoutConfig("toolbar.display");
      return true;
    },
    /**
     * Set the subheader display
     * @returns {boolean}
     */
    subheaderDisplay() {
      return !!this.layoutConfig("subheader.display");
    },

    isDisabled: function () {
      return this.btnDisable;
    },
  },
};
</script>

<style scoped>
h3 {
  font-family: "ubuntu";
  color: #000;
}

.form-div {
  margin: auto;
}

.form-errors {
  color: red;
}

.submit-button {
  background-color: #3d5a80 !important;
}

.submit-button:hover {
  background-color: #002c47 !important;
}

.spinner.spinner-right {
  padding-right: 3.5rem !important;
}
</style>
